import React from 'react'
import MenuDesktop from './Menu/MenuDesktop';
import MenuMobile from './Menu/MenuMobile';

const Header = () => {
  const [bgHeader, setBgHeader] = React.useState('bg-transparent');
  const [menuMobileOpen, setMenuMobileOpen] = React.useState(false)
  React.useEffect(() => {
    if (typeof window !== "undefined") {
      window.addEventListener("scroll", () => { 
        setBgHeader(window.pageYOffset > 0 ? 'bg-white' : 'bg-transparent')
      }
      );
    }
  }, []);

  return (
    <header className={`${bgHeader} transition duration-300 z-10 w-full flex justify-center items-center fixed top-0`}>
      <div className="flex justify-between w-full items-center py-4">
        <div className="px-4">
          <a className="" href="/">
            <picture>
              <img alt="Packlane" src="https://assets.packlane.com/images/logo.svg" />
            </picture>
          </a>
        </div>
        <div className="block lg:hidden p-4" >
          <picture className='absolute right-8 top-8 z-100 cursor-pointer' onClick={() => { setMenuMobileOpen(!menuMobileOpen) }}>
            <img alt="Menu" id="hamburger-js" style={{ filter: (menuMobileOpen && 'invert(1)') }} src="https://assets.packlane.com/images/hamburger.svg" />
          </picture>
          {menuMobileOpen && <MenuMobile />}
        </div>
        <MenuDesktop />
      </div>
    </header>
  )
}

export default Header
